<template>
  <RequestWizardStep name="Review">
    <div class="d-flex flex-column">
      <h4 class="mb-4">Please review the information you have entered before submitting:</h4>

      <slot></slot>
    </div>
  </RequestWizardStep>
</template>

<script>
import RequestWizardStep from '@/components/requestWizard/RequestWizardStep';

export default {
  components: { RequestWizardStep }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .form-label {
    margin-bottom: 0;
  }

  .file-name {
    word-break: break-word;
  }
}
</style>
